import MotionSplitText from "./MotionSplitText";
import { useEffect, useState } from "react";
import { useRecentSets } from "@/hooks/useRecentSets";

export function AudioExampleSlides() {
  const { data: todaySets, isLoading } = useRecentSets();

  const SLIDES = [
    {
      text: "Track my deadlift set, 275 pounds for 3 reps",
      extracted: { exercise: "Deadlift", weight: "275 lb", reps: 3 },
      avatar: "/images/users/1.webp",
    },
    {
      text: "Bench press each side 72 pounds, twice",
      extracted: { exercise: "Bench Press", weight: "188 lb", reps: 2 },
      avatar: "/images/users/2.webp",
    },
    {
      text: "Just did my Squat set, 125 kilograms for 5 reps",
      extracted: { exercise: "Squat", weight: "125 kg", reps: 5 },
      avatar: "/images/users/3.webp",
    },
    {
      text: "Dumbbell curl for my left arm, 40 pounds, 8 times",
      extracted: { exercise: "Dumbbell Curl (Left)", weight: "40 lb", reps: 8 },
      avatar: "/images/users/4.webp",
    },
    {
      text: "Finished 120 pounds lat pulldown, 10 reps",
      extracted: { exercise: "Lat Pulldown", weight: "120 lb", reps: 10 },
      avatar: "/images/users/5.webp",
    },
  ];

  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % SLIDES.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  if (isLoading || (todaySets && todaySets.length > 0)) {
    return null;
  }

  return (
    <div className="w-[70%] mx-auto bg-white/80 border border-bd-overlay rounded-lg py-3 px-6 mb-10  ">
      <div className="flex items-center justify-center h-full">
        <MotionSplitText data={SLIDES[index]} />
      </div>
    </div>
  );
}
